<script>
	export default {
		name: 'IpCliExecuter',
		methods: {
			// app inputs
			ipCliStoreAppInputs(datetime, uid, pageName, pageType, data) {
				const self_ = this;

				const body_ = {
					datetime: datetime,
					uid: uid,
					pageName: pageName,
					pageType: pageType,
					data: data
				}

				return self_.$_ipCliExec_callFunction('postAppInputs', body_)
			},
			ipCliGetAppInputs(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getAppInputs', body_)
			},
			ipCliGetAppInputsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getAppInputs', id, {})
			},
			ipCliUpdateAppInputs(id, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('putAppInputs', id, body)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeleteAppInputs(datetime, uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppInputs({ datetime: datetime, uid: uid })
					}).then(result => {
						const id_ = result[0].id;
						return self_.$_ipCliExec_callFunctionById('deleteAppInputs', id_, {})
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// app logs
			ipCliStoreAppLogs(datetime, created, millisecond, uid, logLevel, logTitle, logText, logDebug, appEnv, appSessionId, appPath, appVersion, appLanguage, appTheme, appScreen, appScreenWidth, appScreenHeight, browserName, browserVersion, browserLanguage, browserPlatform, browserUserAgent, locationLatitude, locationLongitude) {
				const self_ = this;

				const body_ = {
					datetime: datetime,
					created: created,
					millisecond: millisecond,
					uid: uid,
					logLevel: logLevel,
					logTitle: logTitle,
					logText: logText,
					logDebug: logDebug,
					appEnv: appEnv,
					appSessionId: appSessionId,
					appPath: appPath,
					appVersion: appVersion,
					appLanguage: appLanguage,
					appTheme: appTheme,
					appScreen: appScreen,
					appScreenWidth: appScreenWidth,
					appScreenHeight: appScreenHeight,
					browserName: browserName,
					browserVersion: browserVersion,
					browserLanguage: browserLanguage,
					browserPlatform: browserPlatform,
					browserUserAgent: browserUserAgent,
					locationLatitude: locationLatitude,
					locationLongitude: locationLongitude
				}
				// post
				return self_.$_ipCliExec_callFunction('postAppLogs', body_)
			},
			ipCliGetAppLogs(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getAppLogs', body_)
			},
			ipCliGetAppLogsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getAppLogs', id, {})
			},
			ipCliUpdateAppLogs(id, body) { // body = { key: value, key: value, ... }
				//
			},
			ipCliDeleteAppLogs(id, groupCode) {
				//
			},
			// app messages
			ipCliStoreAppMessages(datetime, senderUid, senderName, toUid, toName, pageName, pageType, chatCode, chatName, title, text, attachmentFileUrl, tag, quotedMessage, responseTime) {
				const self_ = this;

				const body_ = {
					datetime: datetime,
					senderUid: senderUid,
					senderName: senderName,
					toUid: toUid,
					toName: toName,
					pageName: pageName,
					pageType: pageType,
					chatCode: chatCode,
					chatName: chatName,
					title: title,
					text: text,
					attachmentFileUrl: attachmentFileUrl,
					tag: tag,
					quotedMessage: quotedMessage,
					responseTim: responseTime
				}
				// post
				return self_.$_ipCliExec_callFunction('postAppMessages', body_)
			},
			ipCliGetAppMessages(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getAppMessages', body_)
			},
			ipCliGetAppMessagesById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getAppMessages', id, {})
			},
			ipCliUpdateAppMessages(id, body) { // body = { key: value, key: value, ... }
				//
			},
			ipCliDeleteAppMessages(id, groupCode) {
				//
			},
			// app users
			ipCliStoreAppUsers(uid, username, fullName, email, phone, postcode, address1, address2, profilePictureUrl, userGroupCode, userGroupName, securityGroupCode, securityGroupName, blocked, disabled) {
				const self_ = this;

				const body_ = {
					uid: uid,
					username: username,
					fullName: fullName,
					email: email,
					phone: phone,
					postcode: postcode,
					address1: address1,
					address2: address2,
					profilePictureUrl: profilePictureUrl,
					userGroupCode: userGroupCode,
					userGroupName: userGroupName,
					securityGroupCode: securityGroupCode,
					securityGroupName: securityGroupName,
					blocked: blocked,
					disabled: disabled
				}

				return self_.$_ipCliExec_callFunction('postAppUsers', body_)
			},
			ipCliGetAppUsers(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getAppUsers', body_)
			},
			ipCliGetAppUsersById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getAppUsers', id, {})
			},
			ipCliUpdateAppUsers(uid, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUsers({ uid: uid })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app users: No data to update...', { uid: uid })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('putAppUsers', id_, body)
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeleteAppUsers(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUsers({ uid: uid })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app users: No data to delete...', { uid: uid })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('deleteAppUsers', id_, {})
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// app user groups
			ipCliStoreAppUserGroups(uid, groupCode, groupName) {
				const self_ = this;

				const body_ = {
					uid: uid,
					groupCode: groupCode,
					groupName: groupName
				}

				return self_.$_ipCliExec_callFunction('postAppUserGroups', body_)
			},
			ipCliGetAppUserGroups(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getAppUserGroups', body_)
			},
			ipCliGetAppUserGroupsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getAppUserGroups', id, {})
			},
			ipCliUpdateAppUserGroups(uid, groupCode, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserGroups({ uid: uid, groupCode: groupCode })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user groups: No data to update...', { uid: uid, groupCode: groupCode })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('putAppUserGroups', id_, body)
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeleteAppUserGroups(uid, groupCode) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserGroups({ uid: uid, groupCode: groupCode })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user groups: No data to delete...', { uid: uid, groupCode: groupCode })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('deleteAppUserGroups', id_, {})
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// app user options
			ipCliStoreAppUserOptions(uid, resetPassword, resetSecurityQuestion) {
				const self_ = this;

				const body_ = {
					uid: uid,
					resetPassword: resetPassword,
					resetSecurityQuestion: resetSecurityQuestion
				}

				return self_.$_ipCliExec_callFunction('postAppUserOptions', body_)
			},
			ipCliGetAppUserOptions(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getAppUserOptions', body_)
			},
			ipCliGetAppUserOptionsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getAppUserOptions', id, {})
			},
			ipCliUpdateAppUserOptions(uid, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserOptions({ uid: uid })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user options: No data to update...', { uid: uid })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('putAppUserOptions', id_, body)
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeleteAppUserOptions(uid, groupCode) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserOptions({ uid: uid })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user options: No data to delete...', { uid: uid })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('deleteAppUserOptions', id_, {})
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// app user point data
			ipCliStoreAppUserPointData(uid, pointGivingAmount, pointRedemptionAmount, pointReturnAmount, pointCancellationAmount, pointExpirationAmount) {
				const self_ = this;

				const body_ = {
					uid: uid,
					pointGivingAmount: pointGivingAmount,
					pointRedemptionAmount: pointRedemptionAmount,
					pointReturnAmount: pointReturnAmount,
					pointCancellationAmount: pointCancellationAmount,
					pointExpirationAmount: pointExpirationAmount
				}

				return self_.$_ipCliExec_callFunction('postAppUserPointData', body_)
			},
			ipCliGetAppUserPointData(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getAppUserPointData', body_)
			},
			ipCliGetAppUserPointDataById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getAppUserPointData', id, {})
			},
			ipCliUpdateAppUserPointData(uid, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserPointData({ uid: uid })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user point data: No data to update...', { uid: uid })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('putAppUserPointData', id_, body)
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeleteAppUserPointData(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserPointData({ uid: uid })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user point data: No data to delete...', { uid: uid })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('deleteAppUserPointData', id_, {})
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// app user security questions
			ipCliStoreAppUserSecurityQuestions(uid, question1, answer1, question2, answer2, question3, answer3) {
				const self_ = this;

				const body_ = {
					uid: uid,
					question1: question1,
					answer1: answer1,
					question2: question2,
					answer2: answer2,
					question3: question3,
					answer3: answer3
				}

				return self_.$_ipCliExec_callFunction('postAppUserSecurityQuestions', body_)
			},
			ipCliGetAppUserSecurityQuestions(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getAppUserSecurityQuestions', body_)
			},
			ipCliGetAppUserSecurityQuestionsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getAppUserSecurityQuestions', id, {})
			},
			ipCliUpdateAppUserSecurityQuestions(uid, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserSecurityQuestions({ uid: uid })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user Security questions: No data to update...', { uid: uid })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('putAppUserSecurityQuestions', id_, body)
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeleteAppUserSecurityQuestions(uid) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserSecurityQuestions({ uid: uid })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user Security questions: No data to delete...', { uid: uid })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('deleteAppUserSecurityQuestions', id_, {})
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// app user training data
			ipCliStoreAppUserTrainingData(uid, courseCode, courseName, moduleCode, moduleName, sectionCode, sectionName, status) {
				const self_ = this;

				const body_ = {
					uid: uid,
					courseCode: courseCode,
					courseName: courseName,
					moduleCode: moduleCode,
					moduleName: moduleName,
					sectionCode: sectionCode,
					sectionName: sectionName,
					status: status // status = opened, started, finished, closed
				}

				return self_.$_ipCliExec_callFunction('postAppUserTrainingData', body_)
			},
			ipCliGetAppUserTrainingData(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getAppUserTrainingData', body_)
			},
			ipCliGetAppUserTrainingDataById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getAppUserTrainingData', id, {})
			},
			ipCliUpdateAppUserTrainingData(uid, courseCode, moduleCode, sectionCode, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserTrainingData({ uid: uid, courseCode: courseCode, moduleCode: moduleCode, sectionCode: sectionCode })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user training data: No data to update...', { uid: uid, courseCode: courseCode, moduleCode: moduleCode, sectionCode: sectionCode })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('putAppUserTrainingData', id_, body)
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeleteAppUserTrainingData(uid, courseCode, moduleCode, sectionCode, groupCode) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserTrainingData({ uid: uid, courseCode: courseCode, moduleCode: moduleCode, sectionCode: sectionCode })
					}).then(result => {
						if(self_.isEmpty(result)) {
/* dev */					self_.logDev('Ip Cli Executer', 'Update app user training data: No data to delete...', { uid: uid, courseCode: courseCode, moduleCode: moduleCode, sectionCode: sectionCode })

							return Promise.resolve()
						} else {
							const id_ = result[0].id;
							return self_.$_ipCliExec_callFunctionById('deleteAppUserTrainingData', id_, {})
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// point givings
			ipCliStorePointGivings(uid, amount, startDate, endDate, pointCriteriumCode, pointCriteriumName, voucherCode, voucherName, description, oldSystemPointGivingId) {
				const self_ = this;

				const body_ = {
					uid: uid,
					amount: amount,
					startDate: startDate,
					endDate: endDate,
					pointCriteriumCode: pointCriteriumCode,
					pointCriteriumName: pointCriteriumName,
					voucherCode: voucherCode,
					voucherName: voucherName,
					description: description,
					oldSystemPointGivingId: oldSystemPointGivingId
				}

				return self_.$_ipCliExec_callFunction('postPointGivings', body_)
			},
			ipCliGetPointGivings(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getPointGivings', body_)
			},
			ipCliGetPointGivingsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getPointGivings', id, {})
			},
			ipCliUpdatePointGivings(id, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('putPointGivings', id, body)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeletePointGivings(id) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('deletePointGivings', id, {})
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// point redemptions
			ipCliStorePointRedemptions(uid, amount, startDate, endDate, purchaseOrderId, description, oldSystemItemOrderId) {
				const self_ = this;

				const body_ = {
					uid: uid,
					amount: amount,
					startDate: startDate,
					endDate: endDate,
					purchaseOrderId: purchaseOrderId,
					description: description,
					oldSystemItemOrderId: oldSystemItemOrderId
				}

				return self_.$_ipCliExec_callFunction('postPointRedemptions', body_)
			},
			ipCliGetPointRedemptions(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getPointRedemptions', body_)
			},
			ipCliGetPointRedemptionsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getPointRedemptions', id, {})
			},
			ipCliUpdatePointRedemptions(id, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('putPointRedemptions', id, body)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeletePointRedemptions(id) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('deletePointRedemptions', id, {})
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// point returns
			ipCliStorePointReturns(uid, amount, startDate, endDate, pointRedemptionId, description, oldSystemItemOrderId) {
				const self_ = this;

				const body_ = {
					uid: uid,
					amount: amount,
					startDate: startDate,
					endDate: endDate,
					pointRedemptionId: pointRedemptionId,
					description: description,
					oldSystemItemOrderId: oldSystemItemOrderId
				}

				return self_.$_ipCliExec_callFunction('postPointReturns', body_)
			},
			ipCliGetPointReturns(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getPointReturns', body_)
			},
			ipCliGetPointReturnsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getPointReturns', id, {})
			},
			ipCliUpdatePointReturns(id, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('putPointReturns', id, body)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeletePointReturns(id) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('deletePointReturns', id, {})
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// point cancellations
			ipCliStorePointCancellations(uid, amount, startDate, endDate, pointGivingId, description, oldSystemPointGivingId) {
				const self_ = this;

				const body_ = {
					uid: uid,
					amount: amount,
					startDate: startDate,
					endDate: endDate,
					pointGivingId: pointGivingId,
					description: description,
					oldSystemPointGivingId: oldSystemPointGivingId
				}

				return self_.$_ipCliExec_callFunction('postPointCancellations', body_)
			},
			ipCliGetPointCancellations(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getPointCancellations', body_)
			},
			ipCliGetPointCancellationsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getPointCancellations', id, {})
			},
			ipCliUpdatePointCancellations(id, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('putPointCancellations', id, body)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeletePointCancellations(id) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('deletePointCancellations', id, {})
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// point expirations
			ipCliStorePointExpirations(uid, amount, startDate, endDate, description) {
				const self_ = this;

				const body_ = {
					uid: uid,
					amount: amount,
					startDate: startDate,
					endDate: endDate,
					description: description
				}

				return self_.$_ipCliExec_callFunction('postPointExpirations', body_)
			},
			ipCliGetPointExpirations(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getPointExpirations', body_)
			},
			ipCliGetPointExpirationsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getPointExpirations', id, {})
			},
			ipCliUpdatePointExpirations(id, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('putPointExpirations', id, body)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeletePointExpirations(id) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('deletePointExpirations', id, {})
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			// training test
			ipCliStoreTrainingTests(datetime, uid, pageName, pageType, courseCode, courseName, moduleCode, moduleName, sectionCode, sectionName, startedDatetime, finishedDatetime, time, score, data) {
				const self_ = this;

				const body_ = {
					datetime: datetime,
					uid: uid,
					pageName: pageName,
					pageType: pageType,
					courseCode: courseCode,
					courseName: courseName,
					moduleCode: moduleCode,
					moduleName: moduleName,
					sectionCode: sectionCode,
					sectionName: sectionName,
					startedDatetime: startedDatetime,
					finishedDatetime: finishedDatetime,
					time: time,
					score: score,
					data: data
				}

				return self_.$_ipCliExec_callFunction('postTrainingTests', body_)
			},
			ipCliGetTrainingTests(body) { // body = { key: value, key: value, ... }
				const self_ = this;

				let body_ = {}
				if(self_.isObject(body)) { body_ = body; }

				return self_.$_ipCliExec_callFunction('getTrainingTests', body_)
			},
			ipCliGetTrainingTestsById(id) {
				const self_ = this;

				return self_.$_ipCliExec_callFunctionById('getTrainingTests', id, {})
			},
			ipCliUpdateTrainingTests(id, body) { // body = { key: value, key: value, ... }
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('putTrainingTests', id, body)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			ipCliDeleteTrainingTests(id) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_ipCliExec_callFunctionById('deleteTrainingTests', id, {})
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_ipCliExec_callFunction(apiName, body) {
				const self_ = this;

				body.env = self_.env;

				return self_.callFunction('ipCliFunction', apiName, { body: body })
			},
			$_ipCliExec_callFunctionById(apiName, id, body) {
				const self_ = this;

				body.env = self_.env;

				return self_.callFunction('ipCliFunction', apiName, { id: id, body: body })
			}
		}
	}
</script>